module.exports = __webpack_public_path__ + "img/1902.i039.011.P.m004.c30.cloud services isometric icons-13.4748fb55.jpg";